import { FC } from 'react';
import { type ButtonProps, Button, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { Row } from '../Layout';

export type ActionButtonType = {
  label: string;
  onClick?: () => void;
  link?: string;
  hidden?: boolean;
  tooltip?: string;
} & Pick<ButtonProps, 'variant' | 'disabled' | 'color' | 'loading'>;

type Props = {
  actions?: Array<ActionButtonType>;
};

const ActionButtons: FC<Props> = ({ actions }) => {
  return (
    <Row centered spacing="sm">
      {actions
        ?.filter((action) => !action.hidden)
        .map((action) => {
          const isExternal = action.link && /^https?:\/\//i.test(action.link);
          return (
            <Tooltip key={action.label} title={action.tooltip ?? ''}>
              <span>
                <Button
                  size="large"
                  variant={action.variant ?? 'outlined'}
                  loading={action.loading}
                  disabled={action.disabled}
                  color={action.color ?? 'primary'}
                  {...(action.link
                    ? isExternal
                      ? { component: 'a', href: action.link }
                      : { component: Link, to: action.link }
                    : { onClick: action.onClick })}
                >
                  {action.label}
                </Button>
              </span>
            </Tooltip>
          );
        })}
    </Row>
  );
};

export default ActionButtons;
